// React
import * as React from "react";
import { connect } from "react-redux";

//QuaggaJS
import Quagga from "quagga";

// Framework
import { Product } from "../../framework/Product";

//Managers
import { MethodRequest_e, NetworkManager } from "../../managers/NetworkManager";

interface QuaggaScannerProps {
    cameraOn: any;
    onDetected: any;
    detectMode: any;
}

/**
 * @description Contain the QuaggaScanner Component
 * @author Lucas Fridez <lfridez@artionet.com>
 * @export
 * @class Home
 * @extends {React.Component}
 */
export default connect<{}, {}, QuaggaScannerProps>((state) => state)(class QuaggaScanner extends React.Component<QuaggaScannerProps, {}> {

    private _scanner;

    /**
     * Creates an instance of QuaggaScanner.
     * @author Lucas Fridez <lfridez@artionet.com>
     * @param {any} props
     * @memberof Home
     */
    constructor(props) {
        super(props);
    }

    getWindowDimensions() {
        const w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName("body")[0],
            x = w.innerWidth || e.clientWidth || g.clientWidth;

        return x;
    }

    setDetectOn() {
        Quagga.onDetected(async (result) => {
            const foundProduct = await NetworkManager.request(`products/code?uid=${result.codeResult.code}`, MethodRequest_e.GET);
            if (foundProduct) {
                this.props.onDetected(foundProduct);
                Quagga.offDetected();
            }
        });
    }

    /**
     * @description Enclenche the camera
     * @author Lucas Fridez <lfridez@artionet.com>
     */
    componentDidMount() {
        this._scanner = Quagga.init({
            decoder: {
                readers: ["ean_reader"]
            },
            frequency: 5,
            inputStream: {
                constraints: {
                    facingMode: "environment"
                },
                name: "Live",
                target: "#scanner",
                type: "LiveStream"
            }
        }, (err) => {
            if (err) {
                alert(err);
                return;
            }
            Quagga.start();
        });

        this.setDetectOn();
    }

    /**
     * @description Stop or enclenche the camera
     * @author Lucas Fridez <lfridez@artionet.com>
     * @param {any} nextProps
     */
    componentWillReceiveProps(nextProps) {
        this.props.onDetected();
        if (!nextProps.cameraOn) {
            Quagga.stop();
        }
        if (nextProps.detectMode) {
            this.setDetectOn();
        }
    }

    /**
     * @description Stop the camera
     * @author Lucas Fridez <lfridez@artionet.com>
     */
    componentWillUnmount() {
        Quagga.stop();
    }

    /**
     * @description Render the Home View
     * @author Lucas Fridez <lfridez@artionet.com>
     * @returns Home View
     * @memberof Home
     */
    render() {
        return (
            <div id="scanner"></div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/UI/components/QuaggaScanner.tsx